import { render } from "./ConfirmEmail.vue?vue&type=template&id=cd8ce3fa&scoped=true&ts=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmail.vue?vue&type=script&lang=ts"

import "./ConfirmEmail.vue?vue&type=style&index=0&id=cd8ce3fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd8ce3fa"]])

export default __exports__